var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"tw-inline-flex tw-items-center tw-rounded-xl tw-py-0.5 tw-text-[12px] tw-text-primary-grey",class:[
    _setup.props.enableUpdatedPropertyTile
      ? 'tw-min-h-[27.5px] tw-max-w-full tw-px-1.5'
      : 'tw-px-2.5',
    {
      'tw-bg-black tw-bg-opacity-50 tw-text-white': [
        'VIEWERS_CURRENT',
        'VIEWERS_LAST_DAY',
      ].includes(_setup.props.type),
      'tw-bg-orange-350': [
        'ENQUIRIES_CURRENT',
        'ENQUIRIES_LAST_DAY',
      ].includes(_setup.props.type),
      'tw-bg-sky-300': ['SHORTLISTED'].includes(_setup.props.type),
    },
  ]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_setup.props.icon),expression:"props.icon"}],staticClass:"tw-mr-2",class:[_setup.props.icon]}),_vm._v(" "),(_setup.props.svgIconPath)?_c('img',{staticClass:"tw-mr-1 tw-h-[16px] tw-w-[16px]",class:_setup.props.enableUpdatedPropertyTile ? 'tw-shrink-0' : '',attrs:{"src":_setup.props.svgIconPath,"alt":"SVG Icon"}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_setup.props.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }